// extracted by mini-css-extract-plugin
export default {"dialogTitle":"baseModal_dialogTitle__Y6wUY","btnPadding":"baseModal_btnPadding__8TcyR","divider":"baseModal_divider__KuLLU","error":"baseModal_error__ilBrI"};